import type { CancelablePromise } from "@/apiClient";

export const cancelRequestOnSignal = <T>(
  request: CancelablePromise<T>,
  signal: AbortSignal
): Promise<T> => {
  const cancel = () => request.cancel();

  if (signal.aborted) {
    cancel();
  } else {
    signal.addEventListener("abort", cancel, { once: true });
  }

  return request.finally(() => signal.removeEventListener("abort", cancel));
};
